$(function () {
    let csWidgets = [];

    /****************************************************************/
    /* GET UTM from URL or Session Storage for CS button generation */
    /****************************************************************/
    let gtmParams = "";
    getUtmParameter("utm_medium, utm_source, utm_campaign, utm_content");

    function getUtmParameter(_parameters) {
        let _parameter = _parameters.split(",");

        $(_parameter).each(function(i, obj) {
            let _obj = obj.trim();

            let utmParameter = sessionStorage.getItem(_obj);

            if (!utmParameter) {
                utmParameter = getUrlParameter(_obj);
            }

            if (utmParameter) {
                sessionStorage.setItem(_obj, utmParameter);

                gtmParams = gtmParams ? gtmParams + " data-csi_" + _obj + "=" +utmParameter + "" : "data-csi_" + _obj + "=" +utmParameter + "";
            }
        });
    }

    /**********************************/
    /* ChannelSight Button Generation */
    /**********************************/
    let countryAbbv = locationInfo.Country.toLowerCase();

    //Loops through all .cs-links and gets the sku
    function rerunCsLinks() {
        $('.cs-links .cswidget').remove();

        let csLinks = $('.cs-links');

        csLinks.each(function (i, obj) {
            let _this = $(obj);
            let _sku = _this.data("product-sku");
            let _csWidgetAsset = "2794"; //default for US country cookie viewing the US site

            //decides which ChannelSight asset to choose based on country cookie and store locale
            if (countryAbbv === "us") {
                if (storeLocale === "es") {
                    _csWidgetAsset = "6859";
                } else if (storeLocale === "fr") { //for US country cookie viewing the FR site
                    _csWidgetAsset = "2795";
                }
            } else if (countryAbbv === "ca") {
                if (storeLocale === "en") { //for CA country cookie viewing the US site
                    _csWidgetAsset = "2796";
                } else if (storeLocale === "es") { //for CA country cookie viewing the ES site
                    _csWidgetAsset = "6860";
                } else if (storeLocale === "fr") { //for CA country cookie viewing the FR site
                    _csWidgetAsset = "2797";
                }
            }

            // Check if the asset already exists in the csWidgets array
            let existingEntry = csWidgets.find(widget => widget.asset === _csWidgetAsset);

            if (existingEntry) {
                // Ensure sku is always treated as a string
                let existingSkuStr = String(existingEntry.sku || '');

                // Convert to array and check if SKU already exists
                const skuList = existingSkuStr.split(',').map(s => s.trim());
                if (!skuList.includes(_sku)) {
                    existingEntry.sku = [...skuList, _sku].join(',');
                }

            } else {
                // Create a new entry if the asset doesn't exist
                csWidgets.push({
                    asset: _csWidgetAsset,
                    sku: _sku
                });
            }

            //process api call on last loop
            if (csLinks.length - 1 === i && csWidgets.length) {
                callCSApi();
            }
        });

        //calls channelsight api to decide whether or not to add the Where To Buy widget - The widget called is dynamic based on csWidgetAsset and all the visible skus combined
        let retries = 0;

        function callCSApi() {
            $(csWidgets).each(function (csWidgetI, csWidgetObj) {
                if (csWidgetObj.asset !== "") {
                    $.ajax({
                        url: "https://api.channelsight.com/api/2.16/feed?key=3240f16b-1f3e-4d5f-9696-50a9763389e5&assetId=" + csWidgetObj.asset + "&pid=" + csWidgetObj.sku,
                        type: 'GET',
                        cache: false,
                        timeout: 50000
                    })
                       .done(function (data) {
                           let productFound = false;
                           $(".f-badge--soldout").removeClass("active");

                           if (!$.isEmptyObject(data)) {
                               $(data).each(function (i, data) {
                                   let _productId = data.ProductId;
                                   let _csContainer = $('.cs-links[data-product-sku="' + _productId + '"]');

                                   if (!$.isEmptyObject(data["RetailerProducts"])) {

                                       //Loop through all widgets and get the widget-type attribute (sometimes on a single page there are multiple of the same div with the same sku)
                                       //adds in the Where To Buy Button
                                       _csContainer.each(function (index, obj) {
                                           let _obj = $(obj);
                                           let _widgetType = _obj.attr("widget-type");
                                           let _widgetCopy = _obj.attr("widget-copy");

                                           if (!productFound) {
                                               let _widgetSource = _obj.attr("widget-wtbsource");
                                               _widgetSource = _widgetSource ? _widgetSource : "lp";
                                               _widgetSource = _widgetSource.toUpperCase();

                                               gtmParams = gtmParams ? gtmParams + " data-wtbsource=" + _widgetSource + "" : "data-wtbsource=" + _widgetSource + "";
                                               productFound = true;
                                           }

                                           if (_widgetType === "button") {
                                               _obj.html('<button class="cswidget wheretobuy btn btn--primary" data-asset-id="' + csWidgetObj.asset + '" data-product-sku="' + _productId + '" ' + gtmParams + '>' + _widgetCopy + '</button>');
                                           } else if (_widgetType === "button-secondary") {
                                               _obj.html('<button class="cswidget wheretobuy btn btn--secondary" data-asset-id="' + csWidgetObj.asset + '" data-product-sku="' + _productId + '" ' + gtmParams + '>' + _widgetCopy + '</button>');
                                           } else if (_widgetType === "link") {
                                               _obj.html('<button class="cswidget wheretobuy cs-widget-inline sk-link-caret sk-link-caret-dark" data-asset-id="' + csWidgetObj.asset + '" data-product-sku="' + _productId + '" ' + gtmParams + '>' + _widgetCopy + '</button>');
                                           }
                                       });
                                   } else {
                                       $(".f-badge--soldout").addClass("active");
                                   }
                               });
                           } else {
                               $(".f-badge--soldout").addClass("active");
                           }
                           reInitializeCS();
                       })
                       .fail(function (error) {
                           if ((countryAbbv === "us" || countryAbbv === "ca") && localStorage.getItem("cserror") !== "true") {
                               localStorage.setItem("cserror", "true"); //set variable to prevent spamming of email for a single user.

                               if (error.statusText === 'timeout') {
                                   if (retries < 1) {
                                       retries++;
                                       callCSApi();
                                   } else {
                                       // console.log("timeout email sent");
                                       $.get("https://ipinfo.io/?token=60f7e30d4fa04d", function (response) {
                                           errorNotify(error, "Timeout - IP:" + response.ip);
                                       }, "json")
                                   }
                               } else {
                                   // console.log("error email sent");
                                   $.get("https://ipinfo.io/?token=60f7e30d4fa04d", function (response) {
                                       errorNotify(error, "Not Timeout - IP:" + response.ip);
                                   }, "json")
                               }
                           }
                       });
                }
            });
        }
    }

    //This is needed to "load" the widgets once added to the page dynamically above
    function reInitializeCS(_rebuild) {
        $("#cswidgetloaderjs, #cswidgetjs").remove();
        if (!document.getElementById('cswidgetloaderjs')) {
            var script = document.createElement('script');
            script.src = 'https://cdn.channelsight.com/widget/scripts/cswidget.loader.js';
            script.id = "cswidgetloaderjs";
            document.head.appendChild(script);

            if (_rebuild) {
                rerunCsLinks();
            }
        }
    }

    $(document).ready(function () {
        if ($(".sk-wishlist").length === 0) {
            rerunCsLinks();
        }
    });

    window.rerunCsLinks = rerunCsLinks;
    window.reInitializeCS = reInitializeCS;
});